import React, { useMemo } from 'react';

function useTelephoneInput() {

    const telephoneOptions = useMemo(() => {
        return { mask: "(000) 000-0000" }
    }, [])

    return {
        telephoneOptions,
        maxLength: 13
    };

}

export default useTelephoneInput;